mutation SetKixieIntegrationIsEnabled($isEnabled: Boolean!) {
    setKixieIntegrationIsEnabled(input: {isEnabled: $isEnabled}) {
        kixieIntegration {
            isEnabledForUser
        }
    }
}
